import { writable, derived } from 'svelte/store';
import { get } from 'svelte/store';
export const outlookData = writable({
  outlookSetting: [],
});
export const getOutlookData = () => {
  return get(outlookData);
};
export const setOutlookData = (data) => {
  outlookData.set(data);
};
